import React, { useState, useEffect, useCallback } from 'react';

export const API_URL = process.env.REACT_APP_API_URL || 'https://hr-api-454591917954.us-central1.run.app';

export const US_STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC',
  'ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

// ── Styles ────────────────────────────────────────────────────────────────────

export const S = {
  body:     { fontFamily:"'Inter',sans-serif", background:'#f5f5f3', minHeight:'100vh', margin:0, padding:0 },
  page:     { maxWidth:860, margin:'0 auto', padding:'2.5rem 1.5rem' },
  card:     { background:'white', border:'1px solid #e5e7eb', borderRadius:12, padding:'2rem', marginBottom:'1.25rem' },
  cardSm:   { background:'white', border:'1px solid #e5e7eb', borderRadius:10, padding:'1rem', marginBottom:'.75rem' },
  h1:       { fontSize:28, fontWeight:600, color:'#1a1a1a', margin:0 },
  h2:       { fontSize:20, fontWeight:600, color:'#1a1a1a', margin:0 },
  sub:      { fontSize:15, color:'#6b7280', marginTop:6 },
  sec:      { fontSize:11, fontWeight:600, letterSpacing:'.07em', color:'#9ca3af', textTransform:'uppercase', marginBottom:'1rem' },
  label:    { display:'block', fontSize:14, fontWeight:500, color:'#374151', marginBottom:6 },
  inp:      (err) => ({ width:'100%', height:42, padding:'0 10px', border:`1px solid ${err?'#ef4444':'#d1d5db'}`, borderRadius:6, fontSize:14, color:'#1a1a1a', background:'white', boxSizing:'border-box', fontFamily:"'Inter',sans-serif" }),
  sel:      (err) => ({ width:'100%', height:42, padding:'0 8px', border:`1px solid ${err?'#ef4444':'#d1d5db'}`, borderRadius:6, fontSize:14, color:'#1a1a1a', background:'white', boxSizing:'border-box', fontFamily:"'Inter',sans-serif" }),
  err:      { fontSize:12, color:'#ef4444', marginTop:3 },
  field:    { marginBottom:'1rem' },
  row2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row3:     { display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:12 },
  divider:  { height:1, background:'#f3f4f6', margin:'1.25rem 0' },
  btnPrimary: { height:44, padding:'0 1.25rem', borderRadius:6, fontSize:14, fontWeight:500, border:'none', background:'#2563eb', color:'white', cursor:'pointer', fontFamily:"'Inter',sans-serif", width:'100%' },
  btnBack:    { height:40, padding:'0 1.25rem', borderRadius:6, fontSize:14, fontWeight:500, border:'1px solid #d1d5db', background:'white', color:'#374151', cursor:'pointer', fontFamily:"'Inter',sans-serif" },
  btnNext:    { height:40, padding:'0 1.25rem', borderRadius:6, fontSize:14, fontWeight:500, border:'none', background:'#2563eb', color:'white', cursor:'pointer', fontFamily:"'Inter',sans-serif" },
  btnGen:     { height:40, padding:'0 1.25rem', borderRadius:6, fontSize:14, fontWeight:500, border:'none', background:'#16a34a', color:'white', cursor:'pointer', fontFamily:"'Inter',sans-serif", display:'flex', alignItems:'center', gap:6 },
  actions:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'1.5rem' },
  chk:        { display:'flex', alignItems:'center', gap:8, fontSize:13, color:'#6b7280', cursor:'pointer', marginTop:6 },
  radio:      { display:'flex', alignItems:'center', gap:8, fontSize:14, color:'#1a1a1a', cursor:'pointer' },
  radioGroup: { display:'flex', flexDirection:'column', gap:8, marginTop:4 },
  ssnWrap:    { display:'flex', alignItems:'center', gap:8 },
  ssnSep:     { color:'#9ca3af', fontSize:18 },
  subCard:    { background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:8, padding:'1rem', marginTop:'.75rem' },
  subHdr:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' },
  rmBtn:      { fontSize:12, color:'#9ca3af', background:'none', border:'none', cursor:'pointer', fontFamily:"'Inter',sans-serif" },
  addBtn:     { fontSize:13, color:'#2563eb', background:'none', border:'none', cursor:'pointer', fontFamily:"'Inter',sans-serif", marginTop:'.75rem', display:'block', padding:0 },
  badge: (status) => ({
    fontSize:11, fontWeight:500, padding:'2px 8px', borderRadius:99,
    background: status==='completed'?'#f0fdf4': status==='in_progress'?'#eff6ff':'#f3f4f6',
    color: status==='completed'?'#16a34a': status==='in_progress'?'#2563eb':'#6b7280',
  }),
  taskCard: (status) => ({
    background:'white', border:`1px solid ${status==='completed'?'#bbf7d0':'#e5e7eb'}`,
    borderRadius:10, padding:'1.25rem 1.5rem', marginBottom:'.875rem',
    display:'flex', alignItems:'center', gap:'1rem', cursor: status==='stub'?'default':'pointer',
    opacity: status==='stub'?0.6:1,
    transition:'border-color .15s',
  }),
  taskIcon: (status) => ({
    width:44, height:44, borderRadius:'50%', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16,
    background: status==='completed'?'#f0fdf4': status==='stub'?'#f3f4f6':'#eff6ff',
    color: status==='completed'?'#16a34a': status==='stub'?'#9ca3af':'#2563eb',
  }),
  progress: { height:8, background:'#e5e7eb', borderRadius:99, overflow:'hidden', marginTop:'1rem' },
  progressBar: (pct) => ({ height:'100%', background:'#2563eb', borderRadius:99, width:`${pct}%`, transition:'width .3s' }),
  uploadArea: { border:'2px dashed #d1d5db', borderRadius:8, padding:'2rem', textAlign:'center', cursor:'pointer', marginTop:'.75rem' },
  spinner: { display:'inline-block', width:14, height:14, border:'2px solid white', borderTopColor:'transparent', borderRadius:'50%', animation:'spin .7s linear infinite' },
};

// ── Helpers ───────────────────────────────────────────────────────────────────

export function maskDOB(v) {
  v = v.replace(/\D/g,'');
  if (v.length > 2) v = v.slice(0,2)+'/'+v.slice(2);
  if (v.length > 5) v = v.slice(0,5)+'/'+v.slice(5);
  return v.slice(0,10);
}
export function maskPhone(v) {
  v = v.replace(/\D/g,'').slice(0,10);
  let o = '';
  if (v.length > 0) o = '('+v.slice(0,3);
  if (v.length >= 4) o += ') '+v.slice(3,6);
  if (v.length >= 7) o += '-'+v.slice(6,10);
  return o;
}

export function Fld({ label, error, children }) {
  return <div style={S.field}>
    {label && <label style={S.label}>{label}</label>}
    {children}
    {error && <div style={S.err}>{error}</div>}
  </div>;
}
export function Inp({ value, onChange, error, style:extra={}, ...rest }) {
  return <input style={{ ...S.inp(!!error), ...extra }} value={value} onChange={e => onChange(e.target.value)} {...rest} />;
}
export function Sel({ value, onChange, error, options, placeholder='Select...' }) {
  return <select style={S.sel(!!error)} value={value} onChange={e => onChange(e.target.value)}>
    <option value="">{placeholder}</option>
    {options.map(o => <option key={o} value={o}>{o}</option>)}
  </select>;
}

export function DocDone({ title, taskId, token, onDone }) {
  const url = `${API_URL}/api/onboarding/file?token=${encodeURIComponent(token)}&task_id=${encodeURIComponent(taskId)}`;
  return <div style={S.page}>
    <div style={S.card}>
      <div style={{ fontSize:40, textAlign:'center', marginBottom:'.5rem' }}>✅</div>
      <div style={{ ...S.h1, textAlign:'center', fontSize:20 }}>{title} saved</div>
      <div style={{ ...S.sub, textAlign:'center', marginBottom:'1.5rem' }}>
        Your completed form has been filed with HR. Open it below if you'd like to check it — there's nothing to download or send.
      </div>
      <a href={url} target="_blank" rel="noopener noreferrer"
         style={{ ...S.btnNext, display:'flex', alignItems:'center', justifyContent:'center', textDecoration:'none' }}>
        Open PDF
      </a>
      <button style={{ ...S.btnBack, width:'100%', marginTop:'.75rem' }} onClick={onDone}>Done</button>
    </div>
  </div>;
}

